import { useMemo } from "react"
import { useAppSelector } from "hooks/redux"
import { getModels } from "resources/models"
import { useModelId } from "./use-model-id"

// Resolves the active dashboard's model display name; null until the model/models list is loaded.
export function useDashboardModelName(): string | null {
  const modelId = useModelId()
  const models = useAppSelector(getModels)
  return useMemo(
    () => (modelId ? models.find((model) => model.id === modelId)?.name ?? null : null),
    [models, modelId],
  )
}
